import { render } from "./Processing.vue?vue&type=template&id=37d7bc72"
import script from "./Processing.vue?vue&type=script&lang=js"
export * from "./Processing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__